import React, { useState } from "react";

export default function TaskFormModal({ existing, onSave, onClose, onDelete }) {
  const isEdit = !!(existing && existing.id);
  const [form, setForm] = useState(() => existing ? {
    title: existing.title || "",
    description: existing.description || "",
    dueDate: existing.dueDate || "",
    repeat: existing.repeat || "none",
    list: existing.list || "Personal",
  } : { title: "", description: "", dueDate: "", repeat: "none", list: "Personal" });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const submit = async () => {
    if (!form.title.trim()) return;
    setSaving(true);
    try {
      const ok = await onSave(form);
      // Modal closes itself on success — parent no longer needs to manage it.
      if (ok !== false) {
        onClose();
        return;
      }
    } catch (_) { /* parent already alerted */ }
    setSaving(false);
  };
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" data-testid="task-form-modal" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{isEdit ? "Edit Task" : "New Task"}</div>
          <button className="modal-close" data-testid="task-form-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-group mb-16">
            <label>Title *</label>
            <input type="text" data-testid="task-title" value={form.title} onChange={e => set("title", e.target.value)} placeholder="e.g. Call James about Sunday rota" autoFocus />
          </div>
          <div className="form-group mb-16">
            <label>Description (optional)</label>
            <textarea data-testid="task-description" value={form.description} onChange={e => set("description", e.target.value)} rows={3} placeholder="Additional details…" />
          </div>
          <div className="form-grid mb-16">
            <div className="form-group">
              <label>Due Date (optional)</label>
              <input type="date" data-testid="task-due" value={form.dueDate} onChange={e => set("dueDate", e.target.value)} />
            </div>
            <div className="form-group">
              <label>Repeat</label>
              <select data-testid="task-repeat" value={form.repeat} onChange={e => set("repeat", e.target.value)}>
                <option value="none">None</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>Task List</label>
            <select data-testid="task-list" value={form.list} onChange={e => set("list", e.target.value)}>
              <option>Personal</option>
              <option>Ministry</option>
              <option>Follow-ups</option>
              <option>Errands</option>
            </select>
          </div>
        </div>
        <div className="modal-footer" style={{ justifyContent: "space-between" }}>
          {existing && onDelete ? (
            <button className="btn btn-danger btn-sm" data-testid="task-delete" onClick={() => { if (window.confirm("Delete this task?")) onDelete(existing.id); }}>Delete</button>
          ) : <span/>}
          <div className="flex gap-8">
            <button className="btn btn-outline" onClick={onClose}>Cancel</button>
            <button className="btn btn-gold" data-testid="task-save" disabled={!form.title.trim() || saving} onClick={submit}>
              {saving ? "Saving…" : (existing ? "Save" : "Create Task")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
